export interface BingoObject {
    id: number
    label: string
    description: string
    imageRef: string
    crossed: boolean
}

export const carBingoObjects = (): BingoObject[] =>
    Array.of(
        {
            id: 1,
            label: '30-skilt',
            description: 'Se ett fartskilt med 30',
            imageRef: '/images/1',
            crossed: false,
        },
        {
            id: 2,
            label: '40-skilt',
            description: 'Se ett fartskilt med 40',
            imageRef: '/images/2',
            crossed: false,
        },
        {
            id: 3,
            label: '50-skilt',
            description: 'Se ett fartskilt med 50',
            imageRef: '/images/3',
            crossed: false,
        },
        {
            id: 4,
            label: '60-skilt',
            description: 'Se ett fartskilt med 60',
            imageRef: '/images/4',
            crossed: false,
        },
        {
            id: 5,
            label: '70-skilt',
            description: 'Se ett fartskilt med 70',
            imageRef: '/images/5',
            crossed: false,
        },
        {
            id: 6,
            label: '80-skilt',
            description: 'Se ett fartskilt med 80',
            imageRef: '/images/6',
            crossed: false,
        },
        {
            id: 7,
            label: '90-skilt',
            description: 'Se ett fartskilt med 90',
            imageRef: '/images/7',
            crossed: false,
        },
        {
            id: 8,
            label: '100-skilt',
            description: 'Se ett fartskilt med 100',
            imageRef: '/images/8',
            crossed: false,
        },
        {
            id: 9,
            label: '110-skilt',
            description: 'Se ett fartskilt med 110',
            imageRef: '/images/9',
            crossed: false,
        },
        {
            id: 10,
            label: 'Oppheving av 30-skilt',
            description: 'Oppheving av 30-sone',
            imageRef: '/images/10',
            crossed: false,
        },
        {
            id: 11,
            label: 'Oppheving av 40-skilt',
            description: 'Oppheving av 40-sone',
            imageRef: '/images/11',
            crossed: false,
        },
        {
            id: 12,
            label: 'Oppheving av 50-skilt',
            description: 'Oppheving av 50-sone',
            imageRef: '/images/12',
            crossed: false,
        },
        {
            id: 13,
            label: 'Oppheving av 60-skilt',
            description: 'Oppheving av 60-sone',
            imageRef: '/images/13',
            crossed: false,
        },
        {
            id: 14,
            label: 'Oppheving av 70-skilt',
            description: 'Oppheving av 70-sone',
            imageRef: '/images/14',
            crossed: false,
        },
        {
            id: 15,
            label: 'Traktor',
            description: 'Du må se en traktor!',
            imageRef: '/images/15',
            crossed: false,
        },
        {
            id: 16,
            label: 'Triller Barnevogn',
            description: 'Se noen trille en barnevogn (fra bilen)!',
            imageRef: '/images/16',
            crossed: false,
        },
        {
            id: 17,
            label: 'Person som spiser is',
            description: 'Se noen spise is!',
            imageRef: '/images/17',
            crossed: false,
        },
        {
            id: 18,
            label: 'Trafikklys',
            description: 'Se ett eller flere trafikklys!',
            imageRef: '/images/18',
            crossed: false,
        },
        {
            id: 19,
            label: 'Rundkjøring',
            description: 'Kjøre i en rundkjøring!',
            imageRef: '/images/19',
            crossed: false,
        },
        {
            id: 20,
            label: 'Firefelts motorvei',
            description: 'Kjøre på firefelts motorvei!',
            imageRef: '/images/20',
            crossed: false,
        },
        {
            id: 21,
            label: 'Seksfelts motorvei',
            description: 'Kjøre på seksfelts motorvei!',
            imageRef: '/images/21',
            crossed: false,
        },
        {
            id: 22,
            label: 'Åttefelts motorvei',
            description: 'Kjøre på Åttefelts motorvei!',
            imageRef: '/images/22',
            crossed: false,
        },
        {
            id: 23,
            label: 'Fotoboks',
            description: 'Se / kjøre forbi en fotoboks!',
            imageRef: '/images/23',
            crossed: false,
        },
        {
            id: 24,
            label: 'Fotoboksblits',
            description: 'Se eller bli tatt i fotoboks!',
            imageRef: '/images/24',
            crossed: false,
        },
        {
            id: 25,
            label: 'Vikepliktsskilt',
            description: 'Se ett vikepliktsskilt',
            imageRef: '/images/25',
            crossed: false,
        },
        {
            id: 26,
            label: 'Rød bil',
            description: 'En bil som er rød',
            imageRef: 'images/rod-bil.png',
            crossed: false,
        },
        {
            id: 27,
            label: 'Campingvogn',
            description: 'En campingvogn i trafikken eller parkert',
            imageRef: 'images/campingvogn.png',
            crossed: false,
        },
        {
            id: 28,
            label: 'Kyr',
            description: 'En flokk eller enkelt ku på beite',
            imageRef: 'images/kyr.png',
            crossed: false,
        },
        {
            id: 29,
            label: 'Tog',
            description: 'Et tog i bevegelse eller parkert',
            imageRef: 'images/tog.png',
            crossed: false,
        },
        {
            id: 30,
            label: 'Trikk',
            description: 'Et tog i bevegelse eller parkert',
            imageRef: 'images/tog.png',
            crossed: false,
        },
        {
            id: 31,
            label: 'Sauer',
            description: 'Sauer i en eng eller ved veikanten',
            imageRef: 'images/sauer.png',
            crossed: false,
        },
        {
            id: 32,
            label: 'Politi',
            description: 'En politibil eller politi i uniform',
            imageRef: 'images/politi.png',
            crossed: false,
        },
        {
            id: 33,
            label: 'Ferrari',
            description: 'En ferrari',
            imageRef: 'images/politi.png',
            crossed: false,
        },
        {
            id: 34,
            label: 'Ambulanse',
            description: 'En ambulanse med eller uten sirene',
            imageRef: 'images/ambulanse.png',
            crossed: false,
        },
        {
            id: 35,
            label: 'Postkasse',
            description: 'En postkasse ved veien',
            imageRef: 'images/postkasse.png',
            crossed: false,
        },
        {
            id: 37,
            label: 'Tunnel',
            description: 'En tunnel man kjører gjennom',
            imageRef: 'images/tunnel.png',
            crossed: false,
        },
        {
            id: 38,
            label: 'Buss',
            description: 'En rutebuss eller turbuss',
            imageRef: 'images/buss.png',
            crossed: false,
        },
        {
            id: 39,
            label: 'Motorsykkel',
            description: 'En motorsykkel',
            imageRef: 'images/mc.png',
            crossed: false,
        },
        {
            id: 40,
            label: 'Gravemaskin',
            description: 'En gravemaskin i arbeid eller parkert',
            imageRef: 'images/gravemaskin.png',
            crossed: false,
        },
        {
            id: 41,
            label: 'Bro',
            description: 'En bro man kjører over eller under',
            imageRef: 'images/bro.png',
            crossed: false,
        },
        {
            id: 42,
            label: 'Sykkel',
            description: 'En syklist på veien',
            imageRef: 'images/sykkel.png',
            crossed: false,
        },
        {
            id: 43,
            label: 'Vindmølle',
            description: 'En vindmølle i landskapet',
            imageRef: 'images/vindmolle.png',
            crossed: false,
        },
        {
            id: 44,
            label: 'Gul bil',
            description: 'En bil som er gul',
            imageRef: 'images/gul-bil.png',
            crossed: false,
        },
        {
            id: 45,
            label: 'Bensinstasjon',
            description: 'En bensinstasjon langs veien',
            imageRef: 'images/bensinstasjon.png',
            crossed: false,
        },
        {
            id: 46,
            label: 'Norsk flagg',
            description: 'Et norsk flagg eller annet flagg',
            imageRef: 'images/flagg.png',
            crossed: false,
        },
        {
            id: 47,
            label: 'Lastebil',
            description: 'En stor lastebil',
            imageRef: 'images/lastebil.png',
            crossed: false,
        },
        {
            id: 48,
            label: 'Kano/kajakk (tak / vann)',
            description: 'En kano eller kajakk på vann eller tak',
            imageRef: 'images/kano/kajakk.png',
            crossed: false,
        },
        {
            id: 49,
            label: 'Telt',
            description: 'Et telt på campingplass eller i naturen',
            imageRef: 'images/telt.png',
            crossed: false,
        },
        {
            id: 50,
            label: 'Bobil',
            description: 'En bobil på veien',
            imageRef: 'images/bobil.png',
            crossed: false,
        },
        {
            id: 51,
            label: 'Ferge',
            description: 'En ferge på vannet eller ved kai',
            imageRef: 'images/ferge.png',
            crossed: false,
        },
        {
            id: 52,
            label: 'Fugl på stolpe',
            description: 'En fugl som sitter på lyktestolpe',
            imageRef: 'images/fugl-pa-stolpe.png',
            crossed: false,
        },
        {
            id: 53,
            label: 'Brannbil',
            description: 'En Brannbil eller brannkonstabel',
            imageRef: 'images/politi.png',
            crossed: false,
        },
        {
            id: 54,
            label: 'Person som jogger',
            description: 'Person som jogger',
            imageRef: 'images/politi.png',
            crossed: false,
        },
        {
            id: 55,
            label: 'Tesla',
            description: 'En Tesla',
            imageRef: 'images/politi.png',
            crossed: false,
        },
        {
            id: 56,
            label: 'Se en forbikjøring',
            description: 'Se noen kjøre forbi',
            imageRef: 'images/politi.png',
            crossed: false,
        },
        {
            id: 57,
            label: 'Parkert i veikanten med problemer',
            description: 'Noen stå parkert med problemer',
            imageRef: 'images/politi.png',
            crossed: false,
        },
        {
            id: 58,
            label: 'Tuting i trafikken',
            description: 'Tuting i trafikken',
            imageRef: 'images/politi.png',
            crossed: false,
        },
        {
            id: 59,
            label: 'Røyke cigarett',
            description: 'Røyke cigarett',
            imageRef: 'images/politi.png',
            crossed: false,
        },
        {
            id: 60,
            label: 'Rush trafikk',
            description: 'Rush Trafikk',
            imageRef: 'images/politi.png',
            crossed: false,
        },
        {
            id: 61,
            label: 'Veiarbeid',
            description: 'Veiarbeid',
            imageRef: 'images/politi.png',
            crossed: false,
        },
        {
            id: 62,
            label: 'Streknings- måling',
            description: 'Strekningsmåling',
            imageRef: 'images/politi.png',
            crossed: false,
        },
        {
            id: 63,
            label: 'Fylkeskilt',
            description: 'Strekningsmåling',
            imageRef: 'images/politi.png',
            crossed: false,
        },
        {
            id: 64,
            label: 'Trafikklys ute av drift',
            description: 'Trafikklys ute av drift',
            imageRef: 'images/politi.png',
            crossed: false,
        },
        {
            id: 65,
            label: 'L bakpå',
            description: 'L bakpå (Øvelseskjøring)',
            imageRef: 'images/politi.png',
            crossed: false,
        },
        {
            id: 66,
            label: 'Alfa Romeo',
            description: 'Alfa Romeo',
            imageRef: 'images/politi.png',
            crossed: false,
        },
        {
            id: 67,
            label: 'Hund',
            description: 'Hund',
            imageRef: 'images/politi.png',
            crossed: false,
        },
        {
            id: 68,
            label: 'Katt',
            description: 'Katt',
            imageRef: 'images/politi.png',
            crossed: false,
        },
        {
            id: 69,
            label: 'Kirke',
            description: 'Kirke',
            imageRef: 'images/politi.png',
            crossed: false,
        },
        {
            id: 70,
            label: 'McDonalds',
            description: 'Se en McDonalds',
            imageRef: 'images/politi.png',
            crossed: false,
        },
        {
            id: 71,
            label: 'Sparke- sykkel',
            description: 'Se en Sparkesykkel',
            imageRef: 'images/politi.png',
            crossed: false,
        },
        {
            id: 72,
            label: 'Busstopp',
            description: 'Se et busstopp',
            imageRef: 'images/politi.png',
            crossed: false,
        },
        {
            id: 73,
            label: 'leddbuss',
            description: 'Se en leddbuss',
            imageRef: 'images/politi.png',
            crossed: false,
        },
        {
            id: 74,
            label: 'Tagging',
            description: 'Se noe som er tagget',
            imageRef: 'images/politi.png',
            crossed: false,
        },
        {
            id: 75,
            label: 'Hjort / elgskilt',
            description: '',
            imageRef: 'images/politi.png',
            crossed: false,
        },
        {
            id: 76,
            label: 'Circle K',
            description: 'Se en Circle K sjappe',
            imageRef: 'images/politi.png',
            crossed: false,
        },
        {
            id: 77,
            label: 'Heisekran',
            description: 'Se en Heisekran',
            imageRef: 'images/politi.png',
            crossed: false,
        },
        {
            id: 78,
            label: 'Bil med grønne skilter',
            description: 'Bil med grønne skilter',
            imageRef: 'images/politi.png',
            crossed: false,
        },
        {
            id: 79,
            label: 'Trailer',
            description: 'Se en Trailer',
            imageRef: 'images/politi.png',
            crossed: false,
        },
        {
            id: 80,
            label: 'Bensinpris under 20kr',
            description: 'Se bensinpris under 20kr',
            imageRef: 'images/politi.png',
            crossed: false,
        },
        {
            id: 81,
            label: 'Bensinpris over 20kr',
            description: 'Se bensinpris over 20kr',
            imageRef: 'images/politi.png',
            crossed: false,
        },
        {
            id: 82,
            label: 'Utenlandsk flagg',
            description: 'Alle flagg utenom det Norske',
            imageRef: 'images/politi.png',
            crossed: false,
        },
        {
            id: 83,
            label: 'Tysk Bilmerke',
            description: 'Tysk Bilmerke',
            imageRef: 'images/politi.png',
            crossed: false,
        },
        {
            id: 84,
            label: 'Japansk Bilmerke',
            description: 'Japansk Bilmerke',
            imageRef: 'images/politi.png',
            crossed: false,
        },
        {
            id: 85,
            label: 'Engelsk Bilmerke',
            description: 'Japansk Bilmerke',
            imageRef: 'images/politi.png',
            crossed: false,
        },
        {
            id: 86,
            label: 'Amerikansk Bilmerke',
            description: 'Japansk Bilmerke',
            imageRef: 'images/politi.png',
            crossed: false,
        },
        {
            id: 87,
            label: 'Fransk Bilmerke',
            description: 'Japansk Bilmerke',
            imageRef: 'images/politi.png',
            crossed: false,
        },
        {
            id: 88,
            label: 'Svensk Bilmerke',
            description: 'Japansk Bilmerke',
            imageRef: 'images/politi.png',
            crossed: false,
        },
        {
            id: 89,
            label: 'En person som haiker',
            description: 'Se en person som haiker',
            imageRef: 'images/politi.png',
            crossed: false,
        },
        {
            id: 90,
            label: 'Veilys som blinker',
            description: 'Se en person som haiker',
            imageRef: 'images/politi.png',
            crossed: false,
        },
        {
            id: 91,
            label: 'Bensinpris over 22kr',
            description: 'Se bensinpris over 20kr',
            imageRef: 'images/politi.png',
            crossed: false,
        },
        {
            id: 92,
            label: 'Bensinpris under 18kr',
            description: 'Se bensinpris over 20kr',
            imageRef: 'images/politi.png',
            crossed: false,
        },
        {
            id: 93,
            label: 'Taxi',
            description: 'Se en taxi',
            imageRef: 'images/politi.png',
            crossed: false,
        },
        {
            id: 94,
            label: 'Taxi',
            description: 'Se en taxi',
            imageRef: 'images/politi.png',
            crossed: false,
        },
        {
            id: 95,
            label: 'Tilhenger',
            description: 'Se en tilhenger',
            imageRef: 'images/politi.png',
            crossed: false,
        },
        {
            id: 96,
            label: 'Takboks',
            description: 'Se en takboks',
            imageRef: 'images/politi.png',
            crossed: false,
        },
        {
            id: 97,
            label: 'Burkerking',
            description: 'Se burkerking',
            imageRef: 'images/politi.png',
            crossed: false,
        },
        {
            id: 98,
            label: 'Innkjøring forbudt',
            description: 'Se innkjøring forbudt skilt',
            imageRef: 'images/politi.png',
            crossed: false,
        },
        {
            id: 99,
            label: 'Innkjøring forbudt',
            description: 'Se innkjøring forbudt skilt',
            imageRef: 'images/politi.png',
            crossed: false,
        },
        {
            id: 100,
            label: 'Reklame på lakken',
            description: 'Bilen har reklame på seg',
            imageRef: 'images/politi.png',
            crossed: false,
        },
        {
            id: 101,
            label: 'Bilskilt med EL',
            description: 'Bilen har skilter med EL',
            imageRef: 'images/politi.png',
            crossed: false,
        },
        {
            id: 102,
            label: 'Minibuss',
            description: 'Du ser en minibuss',
            imageRef: 'images/politi.png',
            crossed: false,
        },
        {
            id: 103,
            label: '7/11',
            description: 'Du ser en seven / eleven',
            imageRef: 'images/politi.png',
            crossed: false,
        },
        {
            id: 104,
            label: 'Volkswagen Golf <3',
            description: 'Du ser den beste bilen i verden, Golf <3',
            imageRef: 'images/politi.png',
            crossed: false,
        },
        {
            id: 105,
            label: 'Sykkel på kjøretøy',
            description: 'Du ser en sykkel på kjøretøyet',
            imageRef: 'images/politi.png',
            crossed: false,
        },
    )
